import React from "react";
import Select from "react-select";

const SelectContent = ({ options, handleChange, endpoint }) => (
    <div style={{marginBottom: '15px', width: '750px'}}>
        <Select
            options={options}
            onChange={handleChange}
            className="ddddd"
            getOptionValue={opt => opt.endpoint}
            getOptionLabel={opt => opt.title}
            placeholder="Select a environment"
            value={endpoint}
        />
        <style>
            {`.css-1aya2g8 {
                border-radius: 2px;
             }`}
            {
                `.css-1nmdiq5-menu {
                    z-index: 99999
                }`
            }
        </style>
    </div>
);

export default SelectContent;
